import { ValueWithCoinCellProps } from './props';
import styles from './styles.module.scss';

export default function ValueWithCoinCell({
  coin,
  value,
  conversion,
  hideCoin,
}: ValueWithCoinCellProps) {
  return (
    <div className={styles.container}>
      {!hideCoin && (
        <div className={styles.container__wrapper}>
          <img
            className={styles['coin-image']}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${coin?.image ?? 'brl.svg'}`}
            alt={coin?.code}
          />
          {coin?.code}
        </div>
      )}

      <p
        className={`${styles.container__value} ${hideCoin ? styles['container__value--hide-coin'] : ''}`}
      >
        {value?.length > 0 ? <p>{value}</p> : <p></p>}
        {conversion && (
          <strong className={styles.container__value}>{conversion}</strong>
        )}
      </p>
    </div>
  );
}
